import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
} from "reactstrap";
import {Form, redirect, useNavigate} from "react-router-dom";

export async function action() {
  console.log('actionRecuperarSenha');
  return redirect("/auth");
}

const Login = () => {
  const navigate = useNavigate();

  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent ">
            <div className="text-muted text-center mt-2">
              <small>FORNEÇA O E-MAIL CADASTRADO</small>
            </div>
          </CardHeader>
          <CardBody className="px-lg-5 py-lg-5">
            <Form method="post" action="login">
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Email"
                    type="email"
                    autoComplete="new-email"
                  />
                </InputGroup>
              </FormGroup>
              <div className="text-center">
                <Button className="my-1" color="primary" type="submit">                  
                  Recuperar Senha
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
        <Row className="mt-3">
          <Col xs="6">
            <a
              className="text-light"
              href="#p1"
              onClick={() => navigate("/")}
            >
              <small>Autenticar</small>
            </a>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default Login;
